import { Slider } from "../Slideshow";
import Discover from "./Discover";
import Categories from "./Categories";
// import Brands from "./Brands";
// import BudgetBuys from "./BudgetBuys";
// import MoreBrands from "./MoreBrands";
import Footer from "../Footer";
// import Navbar from "../NavbarOld";
import Navbar from "../Navbar";
import { Navigate } from "react-router-dom";
import DealOfTheDay from "./DealOfTheDay";
import TopPicks from "./TopPicks";
import ColorsOfTheSeason from "./ColorsOfTheSeason";
import Newness from "./Newness";
import Unmissable from "./Unmissable";

const Home = () => {
  if(JSON.parse(localStorage.getItem("role"))==="admin") return <Navigate to="/admin/dashboard" />;

  return (
    <div>
      <Navbar/>
      <Slider />
      <DealOfTheDay/>
      <TopPicks/>
      <Categories />
      <Discover />
      <Newness/>
      <Unmissable/>
      <ColorsOfTheSeason/>
      {/* <Brands /> */}
      {/* <BudgetBuys /> */}
      {/* <MoreBrands /> */}
      <Footer />
    </div>
  );
};

export default Home;
